import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-impressions',
  templateUrl: './impressions.component.html',
  styleUrls: ['./impressions.component.scss'],
  standalone: false,
})
export class ImpressionsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
